<template>
  <span
    v-if="scheduleInfo.type === '24/7'"
    class="badge badge-schedule-allday"
  >24/7</span>
  <span v-else-if="scheduleInfo.type === 'closed'">
    <span
      v-for="(badge, index) in scheduleInfo.badges"
      :key="badge.color + ':' + badge.label + ':' + index"
      class="badge mr-1"
      :class="'badge-' + badge.color"
    >{{ badge.label }}</span>
  </span>
  <span v-else-if="scheduleInfo.type === 'schedule'">
    <span
      v-for="(badge, index) in scheduleInfo.badges"
      :key="badge.color + ':' + badge.label + ':' + index"
      class="badge mr-1"
      :class="'badge-' + badge.color"
    >{{ badge.label }}</span>
  </span>
</template>

<script>
const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0] // Mon-Sat, Sun last

function formatDayRange(indices) {
  const sorted = [...indices].sort((a, b) => WEEKDAY_ORDER.indexOf(a) - WEEKDAY_ORDER.indexOf(b))
  const ranges = []
  let start = sorted[0]
  let prev = sorted[0]

  for (let i = 1; i <= sorted.length; i++) {
    const cur = sorted[i]
    const prevPos = WEEKDAY_ORDER.indexOf(prev)
    const curPos = WEEKDAY_ORDER.indexOf(cur)
    if (i < sorted.length && curPos === prevPos + 1) {
      prev = cur
    } else {
      ranges.push(start === prev ? DAY_LABELS[start] : `${DAY_LABELS[start]}-${DAY_LABELS[prev]}`)
      start = cur
      prev = cur
    }
  }

  return ranges.join(',')
}

function getScheduleInfo(hoursOfOperation) {
  if (!hoursOfOperation || !hoursOfOperation.length) {
    return { type: '24/7', badges: [] }
  }

  const openDays = []
  const closedDays = []

  hoursOfOperation.forEach((day, index) => {
    if (day.isClosed) {
      closedDays.push(index)
    } else {
      openDays.push(index)
    }
  })

  if (openDays.length === 0) {
    return { type: 'closed', badges: [{ label: 'Closed', color: 'danger' }] }
  }

  // Group open days by time range
  const timeGroups = {}
  openDays.forEach(i => {
    const d = hoursOfOperation[i]
    const key = `${d.openTime.hour}-${d.closeTime.hour}`
    if (!timeGroups[key]) {
      timeGroups[key] = []
    }

    timeGroups[key].push(i)
  })

  const badges = []
  Object.keys(timeGroups).forEach(range => {
    const days = timeGroups[range]
    badges.push({ label: `${range}  ${formatDayRange(days)}`, color: 'schedule-beige' })
  })

  if (closedDays.length > 0) {
    badges.push({ label: formatDayRange(closedDays), color: 'schedule-closed' })
  }

  return { type: 'schedule', badges }
}

export default {
  name: 'ScheduleBadges',

  props: {
    hoursOfOperation: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    scheduleInfo() {
      return getScheduleInfo(this.hoursOfOperation)
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-schedule-beige {
  background-color: rgba(40, 167, 69, 0.08);
  color: #5a9e6a;
}

.badge-schedule-allday {
  background-color: rgba(32, 107, 196, 0.08);
  color: #6a9fd4;
}

.badge-schedule-closed {
  background-color: rgba(220, 53, 69, 0.06);
  color: #d08088;
}
</style>
